<div class="loginWrapper">
  <div class="login_Container ">
      <div class="loginSlider">
          <div class="testimonial_slider">
              <div class="quote_icon">
                  <span class="quote_glyph">&ldquo;</span>
              </div>

              <h1 class="slider_heading">Chasing a Dream.</h1>

              <div class="testimonial_track">
                  <div
                      class="testimonial_slide"
                      *ngFor="let item of testimonials; let i = index"
                      [class.active]="i === activeTestimonial"
                  >
                      <p class="testimonial_quote">{{ item.quote }}</p>
                      <div class="testimonial_author">
                          <div class="author_avatar">{{ getInitials(item.name) }}</div>
                          <div class="author_info">
                              <h4>{{ item.name }}</h4>
                              <p *ngIf="item.subtitle">{{ item.subtitle }}</p>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="slider_controls">
                  <div class="slider_dots">
                      <button
                          type="button"
                          class="dot"
                          *ngFor="let item of testimonials; let i = index"
                          [class.active]="i === activeTestimonial"
                          (click)="goToTestimonial(i)"
                          [attr.aria-label]="'Show testimonial ' + (i + 1)"
                      ></button>
                  </div>
                  <div class="slider_arrows">
                      <button type="button" class="arrow" (click)="prevTestimonial()" aria-label="Previous testimonial">&#8249;</button>
                      <button type="button" class="arrow" (click)="nextTestimonial()" aria-label="Next testimonial">&#8250;</button>
                  </div>
              </div>
          </div>
      </div>
      <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm)" class="login-form">
        <div class="login_fields_con">
          <div class="logo mb-4">
            <img src="assets/images/logo.svg" alt="GradPilots">
          </div>

          <div class="w-full flex flex-column gap-1">
            <label for="email" class="font-bold text-black">Email Address</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-envelope"></i>
              </p-inputGroupAddon>
              <input type="text" pInputText [(ngModel)]="email" #emailInput="ngModel" name="email" required pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$" class="w-full inputstyle" placeholder="you@example.com" />
            </p-inputGroup>
            <small *ngIf="emailInput.dirty && emailInput.invalid" class="ng-dirty ng-invalid text-red-500">
              <ng-container *ngIf="!emailInput.value">Email is required</ng-container>
              <ng-container *ngIf="emailInput.value && emailInput.errors">Enter a valid Email</ng-container>
            </small>
          </div>

          <div class="w-full flex flex-column gap-1">
            <label for="password" class="font-bold text-black">Password</label>
            <p-inputGroup>
              <p-inputGroupAddon>
                <i class="pi pi-lock"></i>
              </p-inputGroupAddon>
              <p-password [(ngModel)]="password" #passwordInput="ngModel" name="password" required [toggleMask]="true" placeholder="Enter your password" styleClass="w-full" [feedback]="false" inputStyleClass="w-full inputstyle">
              </p-password>
            </p-inputGroup>
            <small *ngIf="passwordInput.dirty && passwordInput.invalid" class="ng-dirty ng-invalid text-red-500">Password is required</small>
          </div>

          <div class="w-full text-right" style="margin-top: -15px;">
            <a [routerLink]="['/forgot-password']" class="text-sm hover:underline" style="color: #000086; font-weight: 600;">Forgot password?</a>
          </div>

          <div class="submitBtns mt-1">
            <p-button label='Log in' type="submit" [loading]="loading" styleClass="submitBtn" [disabled]="userForm.invalid"/>
          </div>

          <div class="w-full" style="margin-top: -20px; margin-bottom: -15px;">
            <p-divider layout="horizontal" [align]="'center'">
              <b class="text-gray-400">OR</b>
            </p-divider>
          </div>

          <div class="w-full flex justify-content-center">
            <app-social-login loginType='signIn' class="w-full"></app-social-login>
          </div>

          <div class="text-center mt-3 text-black">
            New to GradPilots? 
            <a [routerLink]="['/student-signup']" class="hover:underline" style="color: #000086; font-weight: 600;">Create a free account</a>
          </div>
        </div>
      </form>

  </div>
</div>
